<template>
  <div class="content">
    <h3>Alterar Senha</h3>
    <div class="line">
      Senha Atual:
      <br />
      <input v-model="current_pwd" type="password" class="inputWire" />
      <br />Nova Senha:
      <br />
      <input v-model="new_pwd" type="password" class="inputWire" />
      <br />
      <br />
      <button @click="changePassword()">Salvar</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/utils/event-bus";
import axios from "axios";
export default {
  computed: {
    ...mapGetters(["getSecurityApi"]),
  },

  data() {
    return {
      current_pwd: null,
      new_pwd: null,
    };
  },

  methods: {
    async changePassword() {
      let vm = this;
      let jwt = localStorage.getItem("jwt");
      EventBus.$emit("showLoading", true);
      if (!vm.current_pwd) {
        EventBus.$emit(
          "showAlert",
          "warning",
          "Campo 'Senha Atual' não preenchido"
        );
        EventBus.$emit("showLoading", false);
        return;
      }
      if (!vm.new_pwd) {
        EventBus.$emit(
          "showAlert",
          "warning",
          "Campo 'Nova Senha' não preenchido"
        );
        EventBus.$emit("showLoading", false);
        return;
      }
      try {
        await axios.put(
          this.getSecurityApi + "/admin/me/change_password",
          {
            current_password: vm.current_pwd,
            new_password: vm.new_pwd,
          },
          {
            headers: { "Content-Type": "application/json", Authorization: jwt },
          }
        );
        EventBus.$emit("showAlert", "success", "Senha atualizada");
        EventBus.$emit("showLoading", false);
      } catch (e) {
        let error = { e };
        console.log(error);
        EventBus.$emit("showAlert", "error", "Erro ao atualizar senha");
        EventBus.$emit("showLoading", false);
      }
    },
  },
};
</script>

<style>
</style>
